/**
 * Scroll reveal for .air-reveal (v4 prototype). One-shot; unobserve after visible.
 */
(function () {
  if (!("IntersectionObserver" in window)) {
    document.querySelectorAll(".air-reveal").forEach(function (el) {
      el.classList.add("is-visible");
    });
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        io.unobserve(entry.target);
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -32px 0px" }
  );

  document.querySelectorAll(".air-reveal").forEach(function (el) {
    io.observe(el);
  });
})();
